import { useEffect, useState } from 'react'

import { Button, Alert, AlertTitle, AlertColor, Paper } from '@mui/material'
import axios from 'axios'
import ReactDOM from 'react-dom'

type Notification = {
  title: string
  message: string
  type: AlertColor
}
const getNotification = async (): Promise<Notification> =>
  axios
    .get('/app-alert/', {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => res.data)

export const AppNotification = () => {
  const [isNotificationVisible, setIsNotificationVisible] = useState(true)
  const [notification, setNotification] = useState<Notification>()

  useEffect(() => {
    try {
      getNotification().then(data => setNotification(data))
    } catch (error) {
      console.log('app-notification', error)
    }
  }, [])

  return isNotificationVisible && notification && notification.message
    ? ReactDOM.createPortal(
        <Paper
          elevation={6}
          sx={{
            backgroundColor: 'white',
            position: 'absolute',
            top: '4px',
            left: '8px',
            width: '400px',
            zIndex: 10000,
          }}
        >
          <Alert
            action={
              <Button
                size="small"
                onClick={() => setIsNotificationVisible(false)}
              >
                Скрыть
              </Button>
            }
            severity={notification.type}
          >
            <AlertTitle>{notification.title}</AlertTitle>
            {notification.message}
          </Alert>
        </Paper>,
        document.body,
      )
    : null
}
